import { render, staticRenderFns } from "./FinanceIncomeAndExpenseWidget.vue?vue&type=template&id=1b1219b0&"
import script from "./FinanceIncomeAndExpenseWidget.vue?vue&type=script&lang=js&"
export * from "./FinanceIncomeAndExpenseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports